<template>
  <div>
    <div>
      <span style="float:left;margin-top:17px;margin-left:6px;">
        <img
          src="@/assets/logo.svg"
          height="48"
          width="48"
          alt="Blubirch Logo"
        />
      </span>
      <span>
        <HeaderComponent :headerTitle="headerText" />
      </span>
    </div>

    <v-container class="ma-0 pa-0" fluid grid-list-lg>
      <v-layout class="ma-0 pa-0" row wrap>
        <v-flex class xs12 style="background-color:grey lighten-3">
          <v-row>
            <!-- <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget(item)">
              <v-card class="pa-4 box_shadow_class">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/wms_dashboard.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">Dashboard</div>
              </v-card>
            </v-col> -->

            <v-col
              xs3
              cols="3"
              sm="3"
              md="3"
              @click="navigateTarget('Disposition')"
              v-if="currentUser.roles.includes('forward_user')"
            >
              <v-card class="pa-4 box_shadow_class">
                <div align="center" justify="center">
                  <img
                    class="mt-3"
                    src="@/assets/images/icons/disposition.svg"
                  />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Test
                </div>
              </v-card>
            </v-col>

            <v-col
              xs3
              cols="3"
              sm="3"
              md="3"
              @click="navigateTarget('Disposition')"
            >
              <v-card class="pa-4 box_shadow_class">
                <div align="center" justify="center">
                  <img
                    class="mt-3"
                    src="@/assets/images/icons/disposition.svg"
                  />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Disposition
                </div>
              </v-card>
            </v-col>
            <!-- Put Away module -->
            <v-col
              xs3
              cols="3"
              sm="3"
              md="3"
              @click="navigateTarget('PutAway')"
              v-if="currentUser.roles.includes('forward_user')"
            >
              <v-card class="pa-4 box_shadow_class">
                <div align="center" justify="center">
                  <img
                    class="mt-3"
                    src="@/assets/images/icons/pickup.svg"
                  />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Putaway
                </div>
              </v-card>
            </v-col>

            <v-col
              xs3
              cols="3"
              sm="3"
              md="3"
              @click="navigateTarget('PutAway')"
            >
              <v-card class="pa-4 box_shadow_class">
                <div align="center" justify="center">
                  <img
                    class="mt-3"
                    src="@/assets/images/icons/pickup.svg"
                  />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Putaway/Pick Up
                </div>
              </v-card>
            </v-col>
            <v-col
              xs3
              cols="3"
              sm="3"
              md="3"
              @click="navigateTarget('Alerts')"
              v-if="
                currentUser.roles.includes('central_admin') ||
                  currentUser.roles.includes('site_admin') ||
                  currentUser.product_access.includes('Alerts') ||
                  currentUser.product_access.includes('All')
              "
            >
              <v-card class="pa-4 box_shadow_class">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/alert.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Alerts
                </div>
              </v-card>
            </v-col>
            <v-col
              xs3
              cols="3"
              sm="3"
              md="3"
              @click="navigateTarget('PendingIssues')"
              v-if="
                currentUser.roles.includes('central_admin') ||
                  currentUser.roles.includes('site_admin') ||
                  currentUser.product_access.includes('Issue Resolution') ||
                  currentUser.product_access.includes('All')
              "
            >
              <v-card class="pa-4 box_shadow_class">
                <div align="center" justify="center">
                  <img
                    class="mt-3"
                    src="@/assets/images/icons/issues.svg"
                    width="108"
                    height="108"
                  />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Issues
                </div>
              </v-card>
            </v-col>
            <v-col
              xs3
              cols="3"
              sm="3"
              md="3"
              @click="navigateTarget('Report')"
              v-if="
                currentUser.roles.includes('central_admin') ||
                  currentUser.roles.includes('site_admin') ||
                  currentUser.product_access.includes('Reports') ||
                  currentUser.product_access.includes('All')
              "
            >
              <v-card class="pa-4 box_shadow_class">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/reports.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Reports
                </div>
              </v-card>
            </v-col>

            <v-col
              xs3
              cols="3"
              sm="3"
              md="3"
              @click="navigateTarget('Settings')"
              v-if="
                currentUser.roles.includes('central_admin') ||
                  currentUser.roles.includes('site_admin')
              "
            >
              <v-card class="pa-4 box_shadow_class">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/settings.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Settings
                </div>
              </v-card>
            </v-col>

            <v-col
              xs3
              cols="3"
              sm="3"
              md="3"
              @click="navigateTarget('StnDocumentUploadList')"
              v-if="
                currentUser.roles.includes('central_admin') ||
                  currentUser.roles.includes('site_admin') ||
                  currentUser.product_access.includes('STN Upload') ||
                  currentUser.product_access.includes('All')
              "
            >
              <v-card class="pa-4 box_shadow_class">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/upload.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  STN Upload
                </div>
              </v-card>
            </v-col>
            <v-col
              xs3
              cols="3"
              sm="3"
              md="3"
              @click="navigateTarget('WmsChart')"
              v-if="
                currentUser.roles.includes('central_admin') ||
                  currentUser.roles.includes('site_admin') ||
                  currentUser.product_access.includes('WmsChart') ||
                  currentUser.product_access.includes('All')
              "
            >
              <v-card class="pa-4 box_shadow_class">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/dashboard.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Chart
                </div>
              </v-card>
            </v-col>
            <v-col
              xs3
              cols="3"
              sm="3"
              md="3"
              @click="navigateTarget('ItemInfo')"
              v-if="
                currentUser.roles.includes('central_admin') ||
                  currentUser.roles.includes('site_admin') ||
                  currentUser.product_access.includes('Item Information') ||
                  currentUser.product_access.includes('All')
              "
            >
              <v-card class="pa-4 box_shadow_class">
                <div align="center" justify="center">
                  <img
                    class="mt-3"
                    src="@/assets/images/icons/service-ex-icon5.png"
                  />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Item Information
                </div>
              </v-card>
            </v-col>
            <v-col
              xs3
              cols="3"
              sm="3"
              md="3"
              @click="navigateTarget('DocumentNumber')"
              v-if="
                currentUser.roles.includes('central_admin') ||
                  currentUser.roles.includes('site_admin') ||
                  currentUser.product_access.includes('Document Search') ||
                  currentUser.product_access.includes('All')
              "
            >
              <v-card class="pa-4 box_shadow_class">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/archive-1.png" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Document Number
                </div>
              </v-card>
            </v-col>
            <v-col
              xs3
              cols="3"
              sm="3"
              md="3"
              @click="navigateTarget('FileUploadList')"
            >
              <v-card class="pa-4 box_shadow_class">
                <div align="center" justify="center">
                  <img
                    class="mt-3"
                    src="@/assets/images/icons/lot_file_upload.svg"
                  />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Lot File Upload
                </div>
              </v-card>
            </v-col>
            <v-col
              xs3
              cols="3"
              sm="3"
              md="3"
              @click="navigateTarget('InboundDocumentIndex')"
            v-if="
                currentUser.roles.includes('central_admin') ||
                  currentUser.roles.includes('site_admin') ||
                  currentUser.product_access.includes('Inbound Documents') ||
                  currentUser.product_access.includes('All')
              "
            >
              <v-card class="pa-4 box_shadow_class">
                <div align="center" justify="center">
                  <img
                    class="mt-3"
                    src="@/assets/images/icons/inbound_documents_card.svg"
                  />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Documents List
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style>
.v-tabs:not(.v-tabs--vertical):not(.v-tabs--right)
  > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes)
  .v-slide-group__prev {
  display: none;
  visibility: hidden;
}
.text-color {
  color: #0357d0;
}
.header-background {
  background-color: #0357d0;
}
.box_shadow_class {
  background: #ffffff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25) !important;
  border-radius: 4px;
}
</style>

<script>
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
import { mapState } from "vuex";
export default {
  data() {
    return {
      active_tab: "Billing",
      headerText: "Warehouse Management System"
    };
  },
  components: {
    HeaderComponent
  },
  computed: mapState(["currentUser", "signedIn"]),
  methods: {
    loadData(tab) {
      this.active_tab = tab;
    },

    navigateTarget(routerName) {
      this.$router.push({ name: routerName });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/api/v1/wms/Dashboard.vue